import { useState } from "react"
import { useSignInWithPassword } from "@convex-dev/auth/providers/password/react"
import { ArrowRight } from "lucide-react"
import { api } from "../../convex/_generated/api"
import { Input } from "@/components/ui/input"
import { Field, Notice, SaveButton } from "@/components/common"

export function LoginPage() {
	const { signIn, pending } = useSignInWithPassword(api.auth.signInWithPassword)
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [error, setError] = useState("")
	return (
		<main className="auth-page">
			<div className="w-full max-w-100">
				<img src="/logo-black.png" width="111" height="29" alt="Sumly" className="mx-auto mb-8" />
				<div className="panel auth-card">
					<h1 className="mb-7 text-3xl font-semibold">Sign in</h1>
					<form
						className="space-y-5"
						onSubmit={async (e) => {
							e.preventDefault()
							setError("")
							try {
								const result = await signIn({ username: email.trim().toLowerCase(), password })
								if (!result.success)
									setError(
										"We couldn’t sign you in. Check your email and password, or try again shortly.",
									)
							} catch {
								setError("We couldn’t sign you in. Please try again shortly.")
							}
						}}
					>
						{error && <Notice error>{error}</Notice>}
						<Field label="Email address">
							<Input
								autoComplete="username"
								type="email"
								required
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="you@sumly.cy"
								className="h-10 mt-2"
							/>
						</Field>
						<Field label="Password">
							<Input
								type="password"
								autoComplete="current-password"
								required
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								className="h-10 mt-2"
							/>
						</Field>
						<div className="pt-1 [&>button]:w-full">
							<SaveButton pending={pending}>
								Sign in <ArrowRight size={15} />
							</SaveButton>
						</div>
					</form>
				</div>
			</div>
		</main>
	)
}
